module.exports = __webpack_public_path__ + "img/og-whatsapp-cover.5adc8537.webp";